import React from 'react'
import _ from 'lodash'
import { Tooltip } from 'antd'
import { Icon, Div } from 'konsys-ui'
import moment from 'moment'
import { ChevronsUpDown } from 'lucide-react'
import {
  InputWithPlaceHolder, ActionSelector, HeaderLabel, CellText, DropdownSelector,
} from '../../../components/repair-job-components'
import { status, statusText } from '../constants'
import { theme } from '../../../styles/_variables'

const { color } = theme

const colorSelector = (val) => {
  switch (val) {
    case status.WAITING:
      return color.coolGrey
    case status.INPROGRESS:
      return color.info
    case status.CANCEL:
      return color.error
    case status.COMPLETED:
      return color.success
    case status.NOTIFY:
      return color.charcoalGrey
    default:
      return color.primaryColor
  }
}

const statusSelector = (value) => {
  switch (value) {
    case status.WAITING:
      return statusText.WAITING
    case status.INPROGRESS:
      return statusText.INPROGRESS
    case status.CANCEL:
      return statusText.CANCEL
    case status.COMPLETED:
      return statusText.COMPLETED
    case status.WATCHING:
      return statusText.WATCHING
    case status.NOTIFY:
      return statusText.NOTIFY
    default: return 'ไม่ระบุ'
  }
}

const newArr = [
  { value: status.ALL, text: statusText.ALL },
  { value: status.NOTIFY, text: statusText.NOTIFY },
  { value: status.WAITING, text: statusText.WAITING },
  { value: status.INPROGRESS, text: statusText.INPROGRESS },
  { value: status.CANCEL, text: statusText.CANCEL },
  { value: status.COMPLETED, text: statusText.COMPLETED },
  { value: status.WATCHING, text: statusText.WATCHING },
]

const ownerArr = [
  { value: 'ALL', text: 'ทั้งหมด' },
  { value: 'PADOONGRICH', text: 'ผดุงฤทธิ์' },
  { value: 'TRANSPORT', text: 'ทรานสปอร์ต' },
  { value: 'OTHER', text: 'อื่นๆ' },
]

export default {
  columns: [{
    Header: () => <HeaderLabel>เลขที่</HeaderLabel>,
    accessor: 'refId',
    Cell: props => <CellText textAlign='center'>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.refId, filter.value),
    sortable: false,
    filterable: true,
    width: 150,
  }, {
    Header: () => (
      <Div display='flex' justifyContent='space-between' alignItems='center'>
        <HeaderLabel>
          วันที่แจ้งซ่อม <ChevronsUpDown color={color.coolGrey} />
        </HeaderLabel>
      </Div>
    ),
    accessor: 'createdAt',
    sortable: true,
    filterable: false,
    Cell: props => <CellText textAlign='center'>{moment(props.value).format('DD/MM/YYYY')}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.companyId, filter.value),
    width: 130,
  }, {
    Header: (
      <Div display='flex' justifyContent='space-between' alignItems='center'>
        <HeaderLabel>
          กำหนดวันที่ซ่อมเสร็จ <ChevronsUpDown color={color.coolGrey} />
        </HeaderLabel>
      </Div>
    ),
    accessor: 'deadlineDate',
    sortable: true,
    filterable: false,
    Cell: props => <CellText textAlign='center'>{moment(props.value).format('DD/MM/YYYY')}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.clientName, filter.value),
    width: 140,
  }, {
    Header: <HeaderLabel>ทะเบียนรถ</HeaderLabel>,
    accessor: 'Truck.plateNumber',
    sortable: false,
    filterable: true,
    Cell: props => <CellText textAlign='center'>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.from, filter.value),
    width: 120,
  }, {
    Header: <HeaderLabel>พนักงานที่แจ้ง</HeaderLabel>,
    accessor: 'CreatedBy.fullname',
    sortable: false,
    filterable: true,
    Cell: props => <Tooltip placement="top" title={props.value}><CellText>{props.value}</CellText></Tooltip>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.Customer.typeOfCharge, filter.value),
    width: 200,
  }, {
    Header: () => <HeaderLabel>เจ้าของรถ</HeaderLabel>,
    accessor: 'Truck.owner.nameTh',
    sortable: false,
    filterable: true,
    Cell: props => <CellText textAlign='center'>{props.value}</CellText>,
    Filter: ({ onChange }) => <DropdownSelector
      width={150}
      key='filter'
      data={ownerArr}
      handleChange={e => onChange(e)}
      filter={true}
      statusAttr='ทั้งหมด'
    />,
    filterMethod: (filter, row) => _.includes(row.companyId, filter.value),
    width: 150,
  }, {
    Header: () => <HeaderLabel>สถานะ</HeaderLabel>,
    accessor: 'status',
    sortable: false,
    filterable: true,
    Cell: props => <CellText textAlign='center' color={colorSelector(props.value)} bold>{statusSelector(props.value)}</CellText>,
    Filter: ({ onChange }) => <DropdownSelector
      width={150}
      key='filter'
      data={newArr}
      handleChange={e => onChange(e)}
      filter={true}
      statusAttr='ทั้งหมด'
    />,
    width: 150,
  }, {
    Header: null,
    accessor: 'action',
    sortable: false,
    filterable: false,
    // Cell: props => <ActionSelector disabled={props.tdProps.rest.disabled} />,
    Cell: props => <ActionSelector props={props} />,
    width: 150,
  }, {
    expander: true,
    width: 65,
    Expander: ({ isExpanded }) => <div>
        {isExpanded
          ? <Icon icon='fal fa-chevron-up' fontSize='18px'/>
          : <Icon icon='fal fa-chevron-down' fontSize='18px'/>}
      </div>,
    style: {
      cursor: 'pointer',
      fontSize: 25,
      padding: '0',
      textAlign: 'center',
      userSelect: 'none',
    },
  }],
}
